import * as React from "react";

const SvgChevrondoubleleft = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="m12 19-7-7 7-7M20 19l-7-7 7-7" />
    </g>
  </svg>
);

export default SvgChevrondoubleleft;
